'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    KooperationResource = _require2.KooperationResource;

module.exports.Kooperation = function (_BaseEntity) {
  _inherits(Kooperation, _BaseEntity);

  _createClass(Kooperation, null, [{
    key: '__name__',
    value: function __name__() {
      return 'kooperation';
    }
  }]);

  function Kooperation(data) {
    _classCallCheck(this, Kooperation);

    var _this = _possibleConstructorReturn(this, (Kooperation.__proto__ || Object.getPrototypeOf(Kooperation)).call(this));

    _this._entityName = 'de.ul.fob.domain.Kooperation';
    _this.beginn = null;
    _this.ende = null;
    _this.endeGeplant = false;
    _this.kooperationsTyp = null;
    _this.kurzbeschreibung = null;
    _this.relevantFuerWeitere = false;
    _this.titelKooperation = null;

    _this.gemeinsameThemen = false;
    _this.gegenseiteHilfe = false;
    _this.gastaufenthalte = false;
    _this.gemeinsameTagungen = false;
    _this.gemeinsamePublikationen = false;
    _this.doktorandenProgramm = false;
    _this.andereKooperation = false;
    _this.kooperationsartFreitext = null;

    _this.ansprechpartner = null;
    _this.beteiligteOrganisationen = null;
    _this.beteiligtePersonen = null;
    _this.organisationseinheit = null;
    _this.weitereOrganisationseinheiten = null;
    _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Kooperation, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'beginn', 'ende', 'endeGeplant', 'kooperationsTyp', 'kurzbeschreibung', 'relevantFuerWeitere', 'titelKooperation', 'gemeinsameThemen', 'gegenseiteHilfe', 'gastaufenthalte', 'gemeinsameTagungen', 'gemeinsamePublikationen', 'doktorandenProgramm', 'andereKooperation', 'kooperationsartFreitext'],
        links: ['ansprechpartner', 'beteiligteOrganisationen', 'beteiligtePersonen', 'organisationseinheit', 'weitereOrganisationseinheiten']
      });
    }
  }, {
    key: 'fetchAnsprechpartner',
    value: function fetchAnsprechpartner() {
      return _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'ansprechpartner');
    }
  }, {
    key: 'fetchBeteiligteOrganisationen',
    value: function fetchBeteiligteOrganisationen() {
      return _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'beteiligteOrganisationen');
    }
  }, {
    key: 'fetchBeteiligtePersonen',
    value: function fetchBeteiligtePersonen() {
      return _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'beteiligtePersonen');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchWeitereOrganisationseinheiten',
    value: function fetchWeitereOrganisationseinheiten() {
      return _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'ansprechpartner'), _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'beteiligteOrganisationen'), _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'beteiligtePersonen'), _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'genericResolve', this).call(this, 'weitereOrganisationseinheiten')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof KooperationResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Kooperation.prototype.__proto__ || Object.getPrototypeOf(Kooperation.prototype), 'fetchQuery', this).call(this, KooperationResource);
      }
    }
  }]);

  return Kooperation;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/kooperation.js
// module id = fgiE
// module chunks = 0